module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "gwi-voucherAdd"
    }
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('form', {
    staticClass: "gwi-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('section', [_c('div', {
    staticClass: "voucher-add-des"
  }, [(_vm.currentSelectCardType.key === '01') ? _c('p', {
    staticClass: "voucher-add-des-content f-normal"
  }, [_vm._v("\n            填写电子健康卡信息\n          ")]) : (_vm.currentSelectCardType.key === '4') ? _c('p', {
    staticClass: "voucher-add-des-content f-normal"
  }, [_vm._v("\n            填写居民健康卡信息\n          ")]) : _c('p', {
    staticClass: "voucher-add-des-content f-normal"
  }, [_vm._v("\n            请填写就诊凭证信息\n          ")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "ipt-item"
  }, [_c('TypeSelect', {
    attrs: {
      "labelName": "卡类型",
      "typeList": _vm.cardTypeList
    },
    on: {
      "type-select": _vm.selectCardType
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "ipt-item flex-row flex-align-center"
  }, [_c('span', {
    staticClass: "f-normal voucher-add-item-left"
  }, [_vm._v("您的姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "gwi-ipt my-ipt flex-1",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ipt-item flex-row flex-align-center"
  }, [_c('span', {
    staticClass: "f-normal voucher-add-item-left"
  }, [_vm._v(_vm._s(_vm.currentSelectCardType.key === "01" ? "身份证号" : "卡号"))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardNo),
      expression: "cardNo"
    }],
    staticClass: "gwi-ipt my-ipt flex-1",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentSelectCardType.key === '4' ?
        '请输入居民健康卡号' :
        '请输入身份证号',
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardNo = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "voucher-add-footer box"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "voucherAdd-btn-submit",
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n          绑定就诊凭证\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voucher-add-bottom-tips"
  }, [_c('p', {
    staticClass: "f-strongest"
  }, [_vm._v("请务必填写真实的身份信息，否则可能无法就诊")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1269e0ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherAdd.vue
// module id = 788
// module chunks = 0